export const Data = [
  {
    type: "card",
    data: [
      {
        title: "Tarot Reading",
        description: `Tarot Card Reading is one of the the ancient arts that is intertwined with fortune-telling. Tarot reading involves the use of a pack of special cards, known as Tarot Cards and hence the name Tarot Reading. These cards help to reveal essential information which may prove to be a turn-up in a person’s life. One thing that constantly itches the human mind is the uncertainty of future events, and this is when Tarot reading comes to our rescue. Compared to Astrology , which is more of a science, Tarot Card Reading is more of an art to foretell what kind of surprise the future may jolt us with.\nWe, being humans, are curious beings. The surprise that tomorrow can bring is a puzzle everyone wants to solve. The uncertainty of future events is something everyone wants to get rid of. Also, if people get hints of what may they come across with, they can set a plan to encounter in the best possible manner. Horoscope serves to be a helping hand for those who want to know what the future holds, so that they can do their best to make it better.`,
      },
    ],
  },
  {
    type: "card",
    data: [
      {
        title: "Tarot Cards in Detail",
        description: `There are 78 cards in a deck of Tarot cards. These cards fall into two different categories:`,
      },
      {
        title: "Minor Arcana",
        description:
          "The Minor Arcana consists of 56 Tarot cards which represent the things that we encounter in our daily life. It quite resembles the deck of 56 cards that we use to play in our everyday life. The Minor Arcana is divided into 4 different type of Tarot cards (just like we have spades, diamonds, hearts and clubs in the regular deck). The Minor Arcana consists of four suits known as Cups, Wands, Swords and Pentacles.",
      },
      {
        title: "Major Arcana",
        description:
          "The Major Arcana is the major contributor in the Tarot Cards, as it consists of the additional 22 cards which were included for the future prediction purposes. It includes cards which have pictures on them and are also known as Trump Cards. The Major Arcana of the Tarot reading carries information right from birth to death, and represents the major aspects of life. The 22 cards are numbered as 1-21, and the 22nd card represented by the Fool is marked as Zero.",
      },
    ],
  },
  {
    type: "card",
    data: [
      {
        title: "Types of Cards in Minor Arcana",
        description: `Ace: They represent the theme of the Suit
Middle Cards: They symbolize various aspects of the Suit
Tens: The Theme represented by the Ace reaches its conclusion with the Tens
Court Cards: They are the face cards, and are further divided into:
King: The King Tarot Card is considered to be the most mature and most masculine of the lot, and is backed by a lot of experience.
Queen: The Queen Tarot Card is the mature feminine personality who represents the inner feelings and self-expression.
Knight: The Knight Tarot Cards are action-oriented and are considered to be extremists.
Page: The Page Tarot Card is represented as an immature playful child who values his own desires and interests above everything.`,
      },
    ],
  },
  {
    type: "card",
    data: [
      {
        title: "Types of Spread",
        description: `The specific layout in which the Tarot cards are laid is known as the Spread. The Cards can have the following Spreads:
The Five Card Spread: It makes use of 5 cards which are spread in the shape of a Plus sign (+) and helps to determine which action should be chosen to drive yourself to the right course of life.
The Eclipse Spread: It uses 7 cards spread in a V shape for answering direct questions.
The Celtic cross Spread: It is considered to be the most complicated Spread to interpret as it uses 10 cards in total. It is generally used to reveal the information about complicated matters.`,
      },
    ],
  },
  {
    type: "card",
    data: [
      {
        title: "Read Tarot Cards",
        description: `Tarot card reading is more of an art than a science, as we said before, and the results also depend upon the psychic powers and intuition of the one reading the cards. The basic process is described as below:
The deck of cards is first shuffled.
The question to be asked is set in mind.
The cards are laid out in Spread.
The next thing to do is to understand the meaning of the Spread.
The meaning is then understood and interpreted`,
      },
    ],
  },
];
